import React, { useState } from 'react'
import { FormGroup } from '@blueprintjs/core'
import Appbar from 'components/Appbar'
import { CitySelect, PageContent } from '@ui'
import CompanyCounters from './CompanyCounters'
import EventCalendarCard from './EventCalendarCard'
import WorldMap from './WorldMap'
import CostsCard from './CostsCard'
import LeasesCard from './LeasesCard'
import MovesCard from './MovesCard'
import EmployeesCard from './EmployeesCard'
import ApprovalCard from './ApprovalCard'
import { useTrackNavigate } from '@hooks'
import track from '@track'
import css from './dashboard.module.scss'

export default function Dashboard() {
  useTrackNavigate()
  const [city, setCity] = useState<string | null>(null)

  return (
    <React.Fragment>
      <Appbar title="Dashboard">{null}</Appbar>
      <PageContent>
        <div style={{ margin: '24px 0' }}>
          <FormGroup inline>
            <CitySelect
              buttonProps={{ iconName: 'map-marker-alt' }}
              useAll
              value={city}
              onChange={(city: string) => {
                setCity(city === 'All Cities' ? null : city)
                track.dashboard({
                  eventName: track.Event.FILTER,
                  props: { filterName: 'city', filterValue: city },
                })
              }}
            />
          </FormGroup>
        </div>
        <CompanyCounters city={city} />
        <div style={{ margin: '20px 0' }}>
          <div className={css.row}>
            <ApprovalCard />
            <div className={css.column}>
              <EmployeesCard city={city} />
            </div>
            <div className={css.column}>
              <CostsCard city={city} />
            </div>
            <div className={css.column}>
              <LeasesCard city={city} />
            </div>
          </div>
          <div className={css.row}>
            <div className={css.column}>
              <MovesCard city={city} />
            </div>
            <div className={css.column}>
              <EventCalendarCard city={city} />
            </div>
          </div>
          <div className={css.row}>
            <div className={css.column}>
              <WorldMap />
            </div>
          </div>
        </div>
      </PageContent>
    </React.Fragment>
  )
}
